
import { debounce, enableScroll } from '~/plugins/helper'

import dropdownState, {
  openDropdown,
  resetDropdown,
  scheduleCloseDropdown,
  setDropdownArrowLeft,
  setDropdownScrolled
} from './nav-dropdown-state'
import { getMenuItems } from './nav-items'

export default {
  data() {
    return {
      isScrolled: false,
      onScroll: null
    }
  },
  computed: {
    isShowMenu() {
      // @ts-ignore
      return this.$store.state.isShowMenu
    },
    menuItems() {
      return getMenuItems()
    },
    isDropdownOpen() {
      return dropdownState.activeId !== null
    }
  },
  watch: {
    $route() {
      resetDropdown()
    }
  },
  updated() {
    this.updateDropdownScrolled()
  },
  // dropdownStateはモジュールスコープで保持されるため再マウント時にリセット
  created() {
    resetDropdown()
  },
  mounted() {
    this.onScroll = debounce(this.handleScroll, 10)
    window.addEventListener('scroll', this.onScroll, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  },
  methods: {
    handleScroll() {
      if (window.scrollY > 0 && window.innerWidth >= 1280 && dropdownState.activeId) {
        scheduleCloseDropdown(0)
      }
    },
    updateDropdownScrolled() {
      // NavMegaMenu.vue positions the dropdown vertically with plain CSS
      // (matching the nav bar's own vw() values), so all that's needed here
      // is whether the scrolled (shorter) nav variant is active.
      setDropdownScrolled(this.$el.classList.contains('header__nav--scrolled'))
    },
    handleItemEnter(item, event) {
      if (item.children && item.children.length) {
        this.updateDropdownScrolled()
        const rect = event.currentTarget.getBoundingClientRect()
        setDropdownArrowLeft(Math.round(rect.left + rect.width / 2))
        openDropdown(item.id)
      } else {
        scheduleCloseDropdown(0)
      }
    },
    handleAreaLeave() {
      scheduleCloseDropdown()
    },
    isActiveItem(item) {
      const currentPath = this.$route.path

      // Handle hash links (article, service) - they are active on homepage
      if (item.link.startsWith('#')) {
        return currentPath === '/'
      }

      // Handle items with link = '/' and hash - active when on homepage with matching hash
      if (item.link === '/' && item.hash && currentPath === '/') {
        return false
      }

      // Handle home page specifically
      if (item.link === '/' && currentPath === '/') {
        return true
      }

      // Handle vision subpages
      if (item.id === 'vision' && currentPath.startsWith('/vision')) {
        return true
      }

      // Handle news subpages
      if (item.id === 'news' && currentPath.startsWith('/news')) {
        return true
      }

      // Handle exact matches for other pages
      return currentPath === item.link || currentPath === item.link.replace(/\/$/, '')
    },
    handleNavClick(link, hash = '') {
      if (hash) {
        // Handle hash navigation with smooth scrolling
        const targetElement = hash.replace('#', '') + '-section'

        // If we're already on the target page, just scroll to the element
        if (this.$route.path === link) {
          this.$store.commit('SET_MENU', false)
          enableScroll()
          this.$scrollTo(`#${targetElement}`, 800, {
            easing: 'ease-in-out',
            offset: -100
          })
          // Update URL hash without triggering page reload
          if (window.location.hash !== hash) {
            window.history.replaceState(null, null, `${link}${hash}`)
          }
          return
        }

        // $nextTickでメニューを閉じる描画を待ってから遷移する
        this.$store.commit('SET_MENU', false)
        enableScroll()
        this.$nextTick(() => {
          window.location.href = `${link}${hash}`
        })
        return
      }

      this.$store.commit('SET_MENU', false)
      enableScroll()
      // Regular navigation without hash
      this.$nextTick(() => {
        window.location.href = link
      })
    },
    handleSubmenuClick(event, child) {
      // newTabは既定動作で別タブを開かせるためpreventDefaultしない
      if (child.newTab) {
        this.closeMenu()
        return
      }
      event.preventDefault()
      this.handleNavClick(child.link)
    },
    closeMenu() {
      this.$store.commit('SET_MENU', false)
      enableScroll()
    }
  }
}
